import {StationMeta} from '../api/types';

/**
 * Apply sensor order and visibility from station.meta to a channel list.
 * Filters out hidden channels and reorders based on saved order.
 *
 * For the merged 'temperature' type, also reads legacy 'tempAndHumidity'
 * config so that previously saved order/hidden preferences are preserved.
 */
export const applySensorConfig = (
  channels: string[],
  sensorType: string,
  meta?: StationMeta,
): string[] => {
  if (!meta) return channels;

  // Merge legacy 'tempAndHumidity' config into 'temperature'
  const types =
    sensorType === 'temperature'
      ? ['temperature', 'tempAndHumidity']
      : [sensorType];

  const hiddenKeys = types.flatMap((t) => meta.sensor_hidden?.[t] || []);

  const orderKeys = types.reduce<string[] | undefined>((acc, t) => {
    const order = meta.sensor_order?.[t];
    if (!order) return acc;
    if (!acc) return order;
    return [...acc, ...order.filter((k: string) => !acc.includes(k))];
  }, undefined);

  // Filter out hidden channels
  let result =
    hiddenKeys.length > 0
      ? channels.filter((ch) => !hiddenKeys.includes(ch))
      : channels;

  // Apply saved order
  if (orderKeys && orderKeys.length > 0) {
    const ordered = orderKeys.filter((key) => result.includes(key));
    const remaining = result.filter((ch) => !orderKeys.includes(ch));
    result = [...ordered, ...remaining];
  }

  return result;
};
